module.exports = __webpack_public_path__ + "img/imageContent24.0f1c96cf.jpg";